import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import {ActionReducer, StoreModule} from '@ngrx/store';
import {reducers, SopiNgrxManagerFeature} from './reducer';
import {EffectsModule} from '@ngrx/effects';
import {LocalStorageConfig, localStorageSync} from 'ngrx-store-localstorage';
import {NgrxManagerService} from './ngrx-manager.service';
import {NgrxManagerEffects} from './effects';
import {NgrxManagerRoutingModule} from './ngrx-manager-routing.module';
import {CommonModule} from '@angular/common';
import {MomentModule} from 'ngx-moment';
import {RemoveDotsModule} from './pipes/remove-dots/remove-dots.module';
import {UuidService} from './providers/uuid.service';
import {SyncAdminDialogComponent} from './sync-admin-dialog/sync-admin-dialog.component';


export function sessionStorage(reducer: ActionReducer<any>): ActionReducer<any> {

    const config: LocalStorageConfig = {
        keys: [
            'sopiNgrxManager'
        ],
        rehydrate: true,
        removeOnUndefined: true
    };

    return localStorageSync(config)(reducer);
}

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(SopiNgrxManagerFeature, reducers, {metaReducers: [sessionStorage]}),
        EffectsModule.forRoot([
            NgrxManagerEffects
        ]),
        NgrxManagerRoutingModule,
        MomentModule,
        RemoveDotsModule
    ],
    declarations: [
        SyncAdminDialogComponent
    ],
    exports: [
        SyncAdminDialogComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class NgrxManagerModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: NgrxManagerModule,
            providers: [
                NgrxManagerService,
                UuidService
            ]
        };
    }
}
